import { ApiError } from '@/lib/api'
import { toast } from 'sonner'

export function handleApiError(err: unknown, fallback: string): void {
  if (err instanceof ApiError) {
    if (err.status === 422 && err.errors) {
      const firstError = Object.values(err.errors)[0]?.[0]
      toast.error(firstError ?? err.message ?? fallback)
    } else {
      toast.error(err.message || fallback)
    }
    return
  }
  toast.error(fallback)
}
